var global = {
    arrayRemove(array, value) {
        for (var a = 0; a < array.length; a++) {
            if (array[a] === value) {
                array.splice(a, 1);
            }
        }
        return array;
    },
    assign(routine, variable) {
        switch (routine) {
            case "Payload":
                if ("undefined" === typeof variable) {
                    return {};
                }
                return variable;
        }
    },
    capitalize(string) {
        return string.replace(/\w+/g, function (a) {
            return a.charAt(0).toUpperCase() + a.substr(1).toLowerCase();
        });
    },
    center(square, peg, left, top, adjLeft, adjTop) {
        let eL = $(peg);
        if (!eL.hasClass("hide")) {
            eL.hide();
        }
        let h = eL.height();
        let w = eL.width();
        var window = square ? square : window;
        try {
            adjLeft = adjLeft ? adjLeft : 0;
            adjTop = adjTop ? adjTop : 0;
            left = left ? left : $(window).width() / 2 - w / 2;
            top = top ? top : $(window).height() / 2 - h / 2;
            left += adjLeft;
            top += adjTop;
            eL.css({
                position: "absolute",
                left: parseInt(left),
                top: parseInt(top),
            });
            eL.removeClass("hide");
            setTimeout(function () {
                eL.show();
            }, 333);
        } catch (e) {
            return false;
        }
        return true;
    },
    errorClass: "gbl-has-warning",
    extractCss(style, attr) {
        let ar = [];
        let re = new RegExp(attr + ":\\s?(.+)", "gi");
        switch (attr) {
            case "background":
                ar = re.exec(style);
                break;
        }
        if (!global.isEmpty(ar)) {
            return ar[1].replace(";", "");
        }
        return "#fff";
    },
    formOk(scope, page) {
        scope = scope ? scope + " " : "";
        let _empty = false;
        /*  advanced field testing... */
        let _fix = null;
        let _hasRules = this.hasRules(page);
        $(scope + ".js-check").each(function () {
            /*  reset... */
            _fix = false;
            switch (this.type) {
                case "checkbox":
                    break;
                case "password":
                    if ("" === this.value) {
                        _fix = true;
                    } else {
                        if (_hasRules) {
                            _fix = window[page].test(this);
                        }
                    }
                    break;
                case "select-one":
                    if (
                        "-1" === this.value ||
                        (0 === parseInt($(this).prop("selectedIndex")) &&
                            $(":selected", this)
                                .text()
                                .match(/select/i)) ||
                        (0 === parseInt(this.value) &&
                            $(this).hasClass("notZero"))
                    ) {
                        _fix = true;
                    } else {
                        if (_hasRules) {
                            _fix = window[page].test(this);
                        }
                    }
                    break;
                case "text":
                case "textarea":
                    if ($(this).hasClass("notzero")) {
                        if (0 === parseInt(this.value)) {
                            _empty = true;
                        }
                    }
                    if ("" === this.value || _empty) {
                        _fix = true;
                    } else {
                        if (_hasRules) {
                            _fix = window[page].test(this);
                        }
                    }
                    break;
            }
            $(this).toggleClass(global.errorClass, _fix);
        });
        return !$(scope + ".js-check").hasClass(global.errorClass);
    },
    hasRules(page) {
        try {
            return $.isFunction(window[page].test);
        } catch (e) {
            return false;
        }
    },
    identifier(_this) {
        if ($(_this).prop("id")) {
            return $(_this).prop("id");
        } else if ($(_this).data("name")) {
            return $(_this).data("name");
        }
        return _this.name;
    },
    ieVersion() {
        let matches = navigator.appVersion.match(/msie (.*?);/i, "");
        if (matches) {
            return parseInt(matches[1]);
        }
        return false;
    },
    isAndroid: !!navigator.userAgent.match(/android/i),
    isApple: !!navigator.platform.match(/mac/i),
    isChrome: !!navigator.userAgent.match(/chrom(e|ium)/i),
    isEmpty(value) {
        return (
            value === false ||
            value === undefined ||
            value === 0 ||
            value === "" ||
            value === null ||
            value == "undefined" ||
            value == -1 ||
            value == "&nbsp;" ||
            value == "[]" ||
            value == "{}" ||
            value == [] ||
            value == "Select One" ||
            (typeof value === "object" && $.isPlainObject(value)) ||
            (typeof value === "object" && $.isEmptyObject(value))
        );
    },
    isEnterKey(e) {
        if (!e) {
            e = event;
        }
        if (e.keyCode == 13) {
            e.preventDefault();
            return true;
        }
        return false;
    },
    isFirefox: !!navigator.userAgent.match(/firefox/i),
    isInternetExplorer: !!navigator.userAgent.match(/msie|\.net/i),
    isIpad: !!navigator.platform.match(/ipad/i),
    isIphone: !!navigator.platform.match(/iphone/i),
    isMac: !!navigator.userAgent.match(/macintosh/i),
    isOpera: !!navigator.userAgent.match(/opera/i),
    isPlaceHolder: !!("placeholder" in HTMLInputElement.prototype),
    isSafari: !!navigator.userAgent.match(/safari/i),
    isTouch: window.matchMedia("(any-pointer: coarse)").matches,
    locals: {
        PASS_TO: null,
        use: {
            WINDOW: false,
        },
        widths: {
            PHONE: 600,
            window: {
                START: 0,
            },
        },
    },
    middleEllipsis(str, max = 40) {
        if (str.length <= max) {
            return str;
        }
        const ext_index = str.lastIndexOf(".");
        const ext = ext_index !== -1 ? str.slice(ext_index) : "";
        const name = ext_index !== -1 ? str.slice(0, ext_index) : str;
        const keep = max - ext.length - 1;
        const front = Math.ceil(keep / 2);
        const back = Math.floor(keep / 2);
        return name.slice(0, front) + "…" + name.slice(-back) + ext;
    },
    messageNumber: 0,
    numberize(string) {
        return parseInt(string.replace(/[^\d]/g, ""));
    },
    openPolicy(policy) {
        const id = `${policy}-dialog`;
        const tpl = document.getElementById(`policy-${policy}`);
        if (!tpl) {
            console.warn(`Policy template not found: policy-${policy}`);
            return;
        }
        if (!document.getElementById(id)) {
            document.body.insertAdjacentHTML("beforeend", `
                <div class="modal fade" data-bs-focus="false" id="${id}" tabindex="-1">
                    <div class="cart__modal modal-dialog modal-dialog-scrollable modal-lg">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div class="modal-body"></div>
                        </div>
                    </div>
                </div>
            `);
        }
        const el = document.getElementById(id);
        if (!el._focus_fix_bound) {
            el.addEventListener("hide.bs.modal", event => {
                event.target.inert = true;
            });
            el.addEventListener("show.bs.modal", event => {
                event.target.inert = false;
            });
            el._focus_fix_bound = true;
        }
        const body = el.querySelector(".modal-body");
        const clone = tpl.content.cloneNode(true);
        body.replaceChildren(clone);
        bootstrap.Modal.getOrCreateInstance(el).show();
    },
    popout() {
        if ($("[name=no_popout]").val() == 1) {
            return false;
        }
        if (top.location !== self.location) {
            top.location.href = self.location.href;
        }
    },
    popup: null,
    prototypes() {
        String.prototype.cleanCurrency = function () {
            return parseFloat(this.replace(/[\$,]/g, "")).toFixed();
        };
        /*
         * @param integer n: length of decimal
         * @param integer p: prefix symbol
         * @param mixed   s: sections delimiter
         * @param mixed   c: decimal delimiter
         * @param integer x: length of whole part
         */
        String.prototype.formatMoney = function (n, p, s, c, x) {
            return parseFloat(this).formatMoney(n, p, s, c, x);
        };
        Number.prototype.formatMoney = function (n, p, s, c, x) {
            n = n || 2;
            var re =
                    "\\d(?=(\\d{" +
                    (x || 3) +
                    "})+" +
                    (n > 0 ? "\\D" : "$") +
                    ")",
                num = this.toFixed(Math.max(0, ~~n));
            return (
                (p || "$") +
                (c ? num.replace(".", c) : num).replace(
                    new RegExp(re, "g"),
                    "$&" + (s || ",")
                )
            );
        };
        Number.prototype.thousands = function () {
            /*  convert... */
            let number = this.toString();
            let re = new RegExp("(-?\\d{1,})(\\d{3})");
            while (re.test(number)) {
                number = number.replace(re, "$1,$2");
            }
            return number;
        };
        Number.prototype.toPrecision = function (precision) {
            precision = precision || 2;
            if (0 === +this) {
                return "0" + (precision ? "." + "0".repeat(precision) : "");
            } else {
                let shift = function (number, exponent) {
                    let numbers = ("" + number).split("e");
                    return +(
                        numbers[0] +
                        "e" +
                        (numbers[1] ? +numbers[1] + exponent : exponent)
                    );
                };
                return shift(
                    Math.round(shift(this, +precision)),
                    -precision
                ).toFixed(precision);
            }
        };
    },
    set(routine, payload) {
        switch (routine) {
            case "Handlers":
                /*  classes... */
                document.querySelectorAll(".global__policy-link").forEach(el => {
                    el.addEventListener("click", function () {
                        global.openPolicy(this.dataset.policy);
                    });
                });
                $(".js-collapser").click(function () {
                    if ($(".js-toggleIcon", this).is(":hidden")) {
                        return false;
                    }
                });
                $(".js-modal").on("show.bs.modal hide.bs.modal", function (e) {
                    switch (e.type) {
                        case "hide":
                            $(".modal-body", this).empty();
                            break;
                        case "show":
                            global.set("Pass-To", e);
                            let target = e.relatedTarget;
                            let src = $(target).data("src");
                            let title = $(target).data("title");
                            if (src) {
                                if (
                                    global.isTouch &&
                                    global.locals.use.WINDOW
                                ) {
                                    global.popup = window.open(
                                        src,
                                        "gbl-popup",
                                        ""
                                    );
                                    return false;
                                } else {
                                    $(".modal-body", this).append(
                                        $(
                                            '<iframe id="gbl-modalIframe" name="modal_iframe"></iframe>'
                                        ).prop("src", src)
                                    );
                                    $(".modal-title", this).html(title);
                                    $("#gbl-modal #btn-modal-reset").toggle(
                                        "1" === $(target).data("reset")
                                    );
                                    if (
                                        global.isTouch &&
                                        (global.isIpad || global.isIphone)
                                    ) {
                                        $("#gbl-modalIframe").css("border", 0);
                                        setTimeout(function () {
                                            $(".modal-body").scrollLeft(10000);
                                            $(".modal-body").scrollLeft(
                                                $(".modal-body").scrollLeft() /
                                                    2
                                            );
                                        }, 333);
                                    }
                                }
                            }
                            break;
                    }
                });
                /*  ids... */
                $("#gbl-toTop").hide();
                $("#gbl-toTop a").click(function () {
                    console.log($($(this)).offset());
                    $("body, html").animate(
                        {
                            scrollTop: 0,
                        },
                        800
                    );
                    return false;
                });
                $(".page-btn-jumpto").click(function () {
                    let $this = this;
                    $("body, html").animate(
                        {
                            scrollTop: $($.attr(this, "href")).offset().top,
                        },
                        800,
                        function () {
                            $($.attr($this, "href") + " .panel-heading")
                                .css({
                                    opacity: 0.1,
                                })
                                .animate(
                                    {
                                        opacity: 1,
                                    },
                                    1000
                                );
                        }
                    );
                    return false;
                });
                $("[canvas='container']").scroll(function () {
                    if ($("[canvas='container']").scrollTop() > 250) {
                        $("#gbl-toTop").fadeIn("slow");
                    } else {
                        $("#gbl-toTop").fadeOut("slow");
                    }
                });
                break;
            case "Pass-To":
                this.locals.PASS_TO = $(
                    $(payload.relatedTarget).data("passto")
                );
                break;
            case "Up":
                $(".js-start .glyphicon").toggle();
                try {
                    /* alertify.defaults.transition = "slide"; */
                    alertify.defaults.theme.ok = "btn btn-success";
                    alertify.defaults.theme.cancel = "btn btn-danger";
                    alertify.defaults.theme.input = "form-control";
                } catch (e) {
                    /* alertify is not defined */
                }
                break;
        }
    },
    setId(name, prefix, suffix) {
        prefix = !prefix ? "" : prefix;
        suffix = !suffix ? "" : suffix;
        return "#" + (prefix + name + suffix);
    },
    setName(name, prefix, suffix) {
        prefix = !prefix ? "" : prefix;
        suffix = !suffix ? "" : suffix;
        return "[name='" + (prefix + name + suffix) + "']";
    },
    setValue(value, prefix, suffix) {
        prefix = !prefix ? "" : prefix;
        suffix = !suffix ? "" : suffix;
        return "[value='" + (prefix + value + suffix) + "']";
    },
    sprintf(format) {
        for (var i = 1; i < arguments.length; i++) {
            format = format.replace(/%s/, arguments[i]);
        }
        return format;
    },
    start() {
        this.set("Up");
        this.set("Handlers");
    },
    textify(value) {
        return this.capitalize(value.toLowerCase().replace(/[_-]/g, " "));
    },
    thousands(n) {
        if (undefined === n) {
            return false;
        }
        let nN = n.toString();
        let re = new RegExp("(-?\\d{1,})(\\d{3})");
        while (re.test(nN)) {
            nN = nN.replace(re, "$1,$2");
        }
        return nN;
    },
    variablize(string) {
        return string
            .replace(/(\&amp;)|\&/g, "and")
            .toLowerCase()
            .replace(/[^\w]/g, "_")
            .toLowerCase();
    },
    vendorPrefix() {
        switch (true) {
            case this.isChrome:
            case this.isSafari:
                return "-webkit-";
            case this.isFF:
                return "-moz-";
            case this.isOpera:
                return "-o-";
            default:
                return "";
        }
    },
};
$(() => {
    global.start();
});
